/* Melora Archive — hero slideshow videos behave like a background, not a player.

   Prestige handles a refused autoplay by switching the browser's native controls on, which
   is the play button iPhones in Low Power Mode (or with "Auto-Play Video Previews" off) show,
   and by setting `suspended` on the video, which also switches off pointer events on the
   slide's own buttons. For the hero we want neither:

   - the native controls stay off, so the video's thumbnail (its poster) stays up instead;
   - the slide's buttons stay clickable (see melora.css);
   - playback is retried on the visitor's first touch / key press / return to the tab, which
     is the earliest moment iOS allows it, so nobody has to find and tap a play button. */
(() => {
  if (window.__meloraHeroVideo) return;
  window.__meloraHeroVideo = true;

  const HERO_MEDIA = 'slideshow-carousel video-media[autoplay]';

  /* The theme sets `video.controls = true` when play() is refused. Undo it right away
     (mutation observers run before the next paint, so the controls never show). */
  new MutationObserver((records) => {
    records.forEach(({ target }) => {
      if (target.tagName === 'VIDEO' && target.controls && target.closest(HERO_MEDIA)) {
        target.controls = false;
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['controls'] });

  /* On a slow connection this script can arrive after the browser has already refused to autoplay,
     so the controls may be on before the observer exists. Clear those too. */
  document.querySelectorAll(`${HERO_MEDIA} video[controls]`).forEach((video) => {
    video.controls = false;
  });

  const resume = () => {
    document.querySelectorAll(`${HERO_MEDIA}[suspended]`).forEach((media) => {
      // the mobile / desktop twin that is not displayed has no layout box, skip it
      if (media.offsetParent) media.play();
    });
  };

  ['touchend', 'pointerup', 'click', 'keydown'].forEach((type) => {
    document.addEventListener(type, resume, { capture: true, passive: true });
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resume();
  });

  window.addEventListener('pageshow', resume);
})();
